// import axios from "axios";
// import { getAccessToken } from "utils";
// import { authRouteConstants } from "constants/routeConstants";
// import { API_URL } from 'constants/appConstants';

// const instance = axios.create({
//     baseURL: API_URL,
//     headers: {
//         Accept: "application/json",
//         "domain-name": (function () {


//             return window.location.host;
//             // return 'https://logotest.webbieshop.com/'
//             // return 'https://thegnhomehaven.webbieshop.com'
//             // return 'nitintest52.webbieshop.com'
//             // return 'cycelStore.webbieshop.com'
//             // return 'accessories.webbieshop.com'
//             // return 'demowebbie.webbieshop.com'
//             // return 'istore.webbieshop.com'
//             // return 'thevetstore.webbieshop.com'
//             // return 'testing-sites.webbieshop.com'
//             // return 'PGtest.webbieshop.com'
//             // return "andrewteachescoding.webbieshop.com"

//             // return  'mclardies.webbieshop.com'
//             // return 'd6-demo.webbieshop.com' //for d6 live demo enviroment
//         })(),
//     }
// });

// instance.interceptors.request.use(
//     function (config) {
//         const token = getAccessToken();
//         if (token)
//             config.headers['Authorization'] = `Bearer ${token}`;
//         return config;
//     }
// )

// instance.interceptors.response.use(
//     function (response) {
//         return response;
//     },
//     function (error) {
//         if (error && error.response && error.response.status === 401) {
//             if (error.response.data && error.response.data.code === "token_not_valid") {
//                 window.location.href = authRouteConstants.LOGOUT
//             }
//         }
//         return error
//     }
// );

// export default instance;

import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { getAccessToken, refreshToken } from "utils";
import { authRouteConstants } from "constants/routeConstants";
import { API_URL } from "constants/appConstants";
import { jwtDecode } from "jwt-decode";
import { recordApiSuccess, generateReferenceId } from "utils/apiActivity";

const instance = axios.create({
    baseURL: API_URL,
    timeout: 18000,
    headers: {
        Accept: "application/json",
        "domain-name": window.location.host,
        // "domain-name": "testing-sites.webbieshop.com",
        // "domain-name": "thesaintshop.webbieshop.com",
        // "domain-name": "premaanta.webbieshop.com",
    }
});

let isRefreshing = false; // Flag to prevent multiple refresh calls
let refreshPromise = null; // Store the refresh promise

// Storefront endpoints that never require a logged-in user — matched
// centrally here so every call site is covered without needing an
// isPublic:true flag on each one (and without missing new call sites).
const PUBLIC_API_PATTERNS = [
    /^\/customer\/api\/mobile-check\/?$/,
    /^\/customer\/api\/create-user\/?$/,
    /^\/customer\/api\/verify-loginOtp\/?$/,
    /^\/customer\/api\/product-search\/?$/,
    /^\/customer\/api\/selected-product-search\/?$/,
    /^\/customer\/products\/\d+\/?$/,
    /^\/customer\/api\/categories\/?$/,
    /^\/customer\/api\/website-info\/?$/,
    /^\/customer\/store-status\/?$/,
    /^\/customer\/api\/about\/?$/,
    /^\/customer\/api\/terms-&-condition\/?$/,
    /^\/customer\/api\/contact-us\/?$/,
    /^\/customer\/api\/featured-products\/?$/,
    /^\/customer\/api\/top-collection-products\/?$/,
    /^\/customer\/get-special-sale\/?$/,
    /^\/customer\/get-shp-images\/?$/,
    /^\/customer\/get-prom-text-content\/?$/,
    /^\/customer\/get-privacy-policy-content\/?$/,
    /^\/product\/report-product\/?$/,
    /^\/sso_d6\/d6sso-signin\/?$/,
];

const isPublicApiPath = (url = "") => {
    const path = url.split("?")[0];
    return PUBLIC_API_PATTERNS.some((pattern) => pattern.test(path));
};

const isTokenExpiringSoon = (token, bufferTime = 600) => {
    // const isTokenExpiringSoon = (token, bufferTime = 86390) => {
    try {
        const { exp } = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        return exp - currentTime < bufferTime;
    } catch (error) {
        return true; // Assume expired if decoding fails
    }
};

instance.interceptors.request.use(async (config) => {
    // Skip appending Authorization header if API is public
    if (config.isPublic || isPublicApiPath(config.url)) {
        return config;
    }

    let token = getAccessToken();

    if (token) {
        if (isTokenExpiringSoon(token)) {
            if (!isRefreshing) {
                isRefreshing = true;
                refreshPromise = refreshToken(); // Call refresh token only once
                token = await refreshPromise; // Wait for refresh to complete
                isRefreshing = false;
            } else {
                token = await refreshPromise; // Wait for the ongoing refresh
            }
        }
        config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
});

// Only GET requests are safe to retry automatically — payment/checkout/order
// POSTs must never be replayed blindly without idempotency support.
const RETRYABLE_STATUS = new Set([502, 503, 504, 408]);
const MAX_RETRIES = 2;
const RETRY_DELAYS_MS = [2000, 5000];

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const isRetryable = (error, config) => {
    if (!config || config.method !== "get") return false;
    if (error.code === "ECONNABORTED") return true; // client-side timeout
    if (!error.response) return true; // network drop / no response at all
    return RETRYABLE_STATUS.has(error.response.status);
};

const friendlyErrorMessage = (error) => {
    if (typeof navigator !== "undefined" && navigator.onLine === false) {
        return "You appear to be offline. Please check your internet connection.";
    }
    if (
        error.code === "ECONNABORTED" ||
        !error.response ||
        RETRYABLE_STATUS.has(error.response?.status)
    ) {
        return "Webbieshop is temporarily taking longer than expected. We are reconnecting automatically.";
    }
    return null;
};

instance.interceptors.response.use(
    (response) => {
        if (response.config?.method === "get" && response.config?.url) {
            recordApiSuccess(response.config.url);
        }
        return response;
    },
    async (error) => {
        const config = error.config;

        if (error?.response?.status === 401) {
            if (error.response.data?.code === "token_not_valid") {
                window.location.href = authRouteConstants.LOGOUT;
            }
            return Promise.reject(error);
        }

        if (isRetryable(error, config)) {
            config.__retryCount = config.__retryCount || 0;
            if (config.__retryCount < MAX_RETRIES) {
                const delay = RETRY_DELAYS_MS[config.__retryCount];
                config.__retryCount += 1;
                await wait(delay);
                return instance(config);
            }
        }

        const isOffline =
            typeof navigator !== "undefined" && navigator.onLine === false;
        const message = friendlyErrorMessage(error);
        if (message) {
            // Offline is the user's own connectivity — nothing server-side to
            // correlate, so skip the reference ID there.
            let displayMessage = message;
            if (!isOffline) {
                const refId = generateReferenceId();
                console.error(
                    `[API error] ref=${refId} url=${config?.url} status=${error?.response?.status ?? "n/a"}`,
                    error,
                );
                displayMessage = `${message} (Ref: ${refId})`;
            }

            // key + preventDuplicate collapse the same message into one toast
            // when several widgets fail at once, instead of a notification storm.
            enqueueSnackbar(displayMessage, {
                variant: "error",
                key: message,
                preventDuplicate: true,
            });
        }

        return Promise.reject(error);
    }
);

export default instance;
